import React, {useState} from 'react';
import { v4 as uuidv4 } from "uuid"
import Cookies from "universal-cookie"
import SearchList from './SearchList';
import { Link } from "gatsby"
import FloorPlanModal from "./floorPlanModal"
import VideoPlay from "../Play/property-results-video"
import PropertyBox from '../property-box/property-box';
import { Col, Container, Row } from "react-bootstrap";
// import parse from "html-react-parser"
import Noimg from "../../components/no-img/Noimg"
import { currencyFormat } from '@components/common/utils';
import noImg from "../../images/no-image.png"
import ContentBlock from "../content/Content";
import Card from "../card/card"
import classNames from "classnames"
import LinkIcon from "../link-icon/link-icon"
import { ShowProcessedImage } from '../common/ggfx-client/module/components/show-image';
import imageConfig from "../../../static/images/config.json"
import ImageTransform from "@components/common/ggfx-client/module/components/image-transform";
import PropertyCalloutBanner from '../callout-banner/property-callout-banner';
import PriceComp from "@components/Property/Price"
import Modal from 'react-bootstrap/Modal';
import BookAViewingForm from "../../Forms/BookAViewing"
import CardLet from '../news-lettings/card-let';
import PropertyEnquireForm from '../../Forms/PropertyEnquire';
import NewHomePropertyBox from '../property-box/new-homes-property-box';
let text_truncate = function(str, length, ending) {
    length = 150;
    //

    if (ending == null) {
      ending = '...';
    }
    
    if (str?.length > length) {
      return str?.substring(0, length - ending.length) + ending;
    } else {
      return str === "undefined" ? null : str;
    }
  };

const mycookies = new Cookies()
const InfiniteHits = ({
  hits,
  // hasPrevious,
  // refinePrevious,
  // hasMore,
  // refineNext,
  // location,
  tag,
  source,
  map,
  type,
  department,
  pstatustype,
  nostats
  // userObjects,
}) => {
  const [showForm, setShowForm] = useState(false);
  const [index, setIndex] = useState(null);
  const openform = (i) => {
          if(index === i){
            setShowForm(!showForm)
          setIndex(null)
          }
          else {
            setShowForm(!showForm)
          setIndex(i)
          }
  }
  return (
  <>
    {hits?.map((hitItem, i) => {
      // property details url structure
      // console.log("elb", hitItem)
      let uriStr = ""
      let mysale = ""
      let hit = { ...hitItem }
      // mapping
      hit.searchType = hit.searchType || hit.search_type;

      // if (hit.searchType === "sales" && hit.department === "residential") {
      //   uriStr = `property-for-sale/`
      //   mysale = `myResSaleProp`
      // } else if (
      //   hit.searchType === "lettings" &&
      //   hit.department === "residential"
      // ) {
      //   uriStr = `property-to-rent/`
      //   mysale = `myResRentProp`
      // }

      if (tag === "sold") {
        uriStr = `property-sold/`
        mysale = `myResSaleProp`
      } else if (tag === "let") {
        uriStr = `property-let/`
        mysale = `myResRentProp`
      }

      let url_one = ""
      let photoplans = false

      if (hit.virtual_tour) {
        url_one = String(hit.virtual_tour)
        photoplans = url_one.indexOf("photoplans.planup") > -1
      }
      // property details url structure
        hit.price_qualifier = 'Price from';
        uriStr = 'new-homes-for-sale/';
        hit.bedroom = hit.bedroom;

        //remove html tags from a string, leaving only the inner text
        function removeHTML(str) {
          var tmp = document.createElement("DIV");
          tmp.innerHTML = str;
          return tmp.textContent || tmp.innerText || "";
        }

        hit.description = removeHTML(hit.description)
        let processedImages = JSON.stringify({});
        if(nostats){
          if (hit.imagetransforms?.upload_images_Transforms) {
            processedImages = hit.imagetransforms?.upload_images_Transforms;
          }
  
        }else {
          if (hit.imagetransforms?.images_Transforms) {
            processedImages = hit.imagetransforms?.images_Transforms;
          }
  
        }
      return (
        <>
        {nostats && i== 0 ? 
<div className='div-search'>
<h5>
              Unfortunately, we do not currently have any new homes that match
              your search criteria.</h5>
              <br/>
              <p>We have selected some of our showcase new homes for you to browse below. Alternatively, you can search again in the bar above.</p>
            <br/>
            <br/>
            <br/>
            </div> 
            : null}
        <div
          className="property-card mysingleproperty"
          id={`item${nostats ? hit?.id : hit.objectID}`}
          data-objectid={`item${nostats ? hit?.id : hit.objectID}`}
          data-lat={hit?._geoloc?.lat}
          data-lng={hit?._geoloc?.lng}
        >

{pstatustype === "Completed" || pstatustype === "Completed" && map ? 
         
         <Card>
          {pstatustype === "Completed" ?  <>
           <div className={hit?.status === "Completed" ? "property-box__badge yellow" : "property-box__badge"}>{hit?.status === "Completed" ? "Completed" : "For Sale"}</div>
           {hit?.images1.length > 0 ?
             <ShowProcessedImage
               images={hit?.images1[0]}
               attr={{ className: '', alt: `${hit?.developer?hit?.developer:""} - Strakers Estate Agents` }}
               transforms={imageConfig.offplan.searchResults2.sizes} />
           : 
          //  <img src={noImg} />
           <Noimg imagename="coming-soon-image.Image.searchResults2" />
           } </> :
              <Link to={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}`}>
                <div className={hit?.status === "Completed" ? "property-box__badge yellow" : "property-box__badge"}>{hit?.status === "Completed" ? "Completed" : "For Sale"}</div>

              {nostats ? 
                <ImageTransform
                imagesources={hit?.images && hit?.images[0]?.url}
                // renderer="srcSet"
                imagename={"offplan.upload_images.searchResults2"}
                attr={{ alt: `${hit?.developer?hit?.developer:""} - Strakers Estate Agents`, className: "" }}
                imagetransformresult={processedImages}
                id={hit.id}
              /> :
              hit?.images1.length > 0 ?
                <ShowProcessedImage
                  images={hit?.images1[0]}
                  attr={{ className: '', alt: `${hit?.developer?hit?.developer:""} - Strakers Estate Agents` }}
                  transforms={imageConfig.offplan.searchResults2.sizes} />
              : <Link to={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}`}>
                <Noimg imagename="coming-soon-image.Image.searchResults2" />
                </Link>}  
              </Link>}
              <Card.Body>
              <h5>
                  {pstatustype === "Completed" ? 
                  <>{hit?.developer ? hit?.developer : ''}</>
                  :
                  <>
                      {hit?.developer ? hit?.developer : ''}
                    </>
                    }
                  </h5>
                  <h6 className='mb-20'>{hit?.display_address}</h6>
                  <div className="card__description d-flex">
                  <PriceComp type="newhomes" {...hit} />
                    {/* {hit?.price_qualifier !== "0" ? hit?.price_qualifier : ""} <strong>{currencyFormat(hit?.price, '£', false)}</strong> */}
                  </div>
                  {hit?.developer_logo &&
                  <div className='dev-logo'>
                    <img src={hit?.developer_logo} alt={hit?.developer + ", " +hit?.area+" - Strakers Estate Agents"} />
                  </div>
    }
              </Card.Body>
             
            </Card>
            :
            <>
            {i % 4 === 0 && i !== 0 &&
            <PropertyCalloutBanner addShell={false} />
            }
            {nostats ?
            <NewHomePropertyBox
            map={map}
            pstatustype={pstatustype ? pstatustype : hit?.status}
            key={i}
            badge={hit?.status === "Completed" ? "Completed" : "For Sale"}
            collection="newhomes"
            className="mysingleproperty"
            id={`${nostats ? hit?.id : hit.objectID}`}
            bed={hit?.bedroom} bathroom={hit?.bathroom} room={hit?.reception}
            bedroom_text={hit?.bedroom_text}
            images={nostats ? hit?.images[0] : hit?.images1}
            images1={nostats ? hit?.images?.slice(1, 4) : hit?.images2}
            imagetransforms={hit?.imagetransforms}
            // id={hit?.id}
            nostats={nostats}
            url={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}`}
            onClick={(e) => openform(i)}
            hidebtn={hit.status === "Completed" ? true : false}
            display_address={hit?.display_address}

          >
            <Row className="justify-content-between">
              <Col>
                <h4>
                {pstatustype === "Completed" ? 
                <>{hit?.developer ? hit?.developer : ''}</>
                :
                  <Link to={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}`}>
                    {hit?.developer ? hit?.developer : ''}
                  </Link>}
                </h4>
                <h6 className='mb-20'>{hit?.display_address}</h6>
                <h5>
                <PriceComp type="newhomes" {...hit} />
                  {/* {hit?.price_qualifier !== "0" ? hit?.price_qualifier : ""} <strong>{currencyFormat(hit?.price, '£', false)}</strong> */}
                </h5>
                {hit?.developer_logo &&
                <div className='dev-logo'>
                  <img src={hit?.developer_logo} alt={hit?.developer + ", " +hit?.area} />
                </div>
  }
              </Col>
            </Row>
            {hit?.description ?
            <p className="d-none d-md-block">
              {/* <ContentBlock Content={text_truncate(hit?.description)} /> */}
              <div
          dangerouslySetInnerHTML={{ __html: text_truncate(hit?.description) }}
        />

            </p>
  : null}
          </NewHomePropertyBox>
            :
            <PropertyBox
              map={map}
              pstatustype={pstatustype ? pstatustype : hit?.status}
              key={i}
              badge={hit?.status === "Completed" ? "Completed" : "For Sale"}
              collection="newhomes"
              className="mysingleproperty"
              id={`${nostats ? hit?.id : hit.objectID}`}
              bed={hit?.bedroom} bathroom={hit?.bathroom} room={hit?.reception}
              bedroom_text={hit?.bedroom_text}
              images={nostats ? hit?.images[0] : hit?.images1}
              images1={nostats ? hit?.images?.slice(1, 4) : hit?.images2}
              imagetransforms={hit?.imagetransforms}
              // id={hit?.id}
              nostats={nostats}
              url={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}`}
              onClick={(e) => openform(i)}
              hidebtn={hit.status === "Completed" ? true : false}
              display_address={hit?.display_address}

            >
              <Row className="justify-content-between">
                <Col>
                  <h4>
                  {pstatustype === "Completed" ? 
                  <>{hit?.developer ? hit?.developer : ''}</>
                  :
                    <Link to={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}`}>
                      {hit?.developer ? hit?.developer : ''}
                    </Link>}
                  </h4>
                  <h6 className='mb-20'>{hit?.display_address}</h6>
                  <h5>
                  <PriceComp type="newhomes" {...hit} />
                    {/* {hit?.price_qualifier !== "0" ? hit?.price_qualifier : ""} <strong>{currencyFormat(hit?.price, '£', false)}</strong> */}
                  </h5>
                  {hit?.developer_logo &&
                  <div className='dev-logo'>
                    <img src={hit?.developer_logo} alt={hit?.developer + ", " +hit?.area} />
                  </div>
    }
                </Col>
              </Row>
              {hit?.description ?
              <p className="d-none d-md-block">
                {/* <ContentBlock Content={text_truncate(hit?.description)} /> */}
                <div
          dangerouslySetInnerHTML={{ __html: text_truncate(hit?.description) }}
        />

              </p>
    : null}
            </PropertyBox>
    }
            </>
          
    }
          {/* {index} -- {i} -- {showForm ? "true" : 'false'} */}
          <Modal className="teamdetails popupForm" backdrop="static" size="lg" show={index === i && showForm} onHide={() => { setShowForm(false);setIndex(null) }}>
                                            <Modal.Header closeButton>
                                                <Modal.Title> <div className="form__head">
          <h4>Enquire about New Homes</h4>
        </div>
</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body> 
                                                <PropertyEnquireForm
                                                id={hit?.id}
                                                 property_img={hit?.images1 && hit?.images1[0]['608x404']}
                                                  page_url={`${process.env.GATSBY_SITE_URL}${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}`}
                                                   property_title={hit?.developer}
                                                    type={hit?.search_type}
                                                data={hit}
                                                newhome={true}
                                                />  
                                            </Modal.Body>

                                        </Modal>
          {/* {tag == "sold" || tag == "let" ? (
            <div className="result-tile">
              <div className="map-wrapper">
                <SearchList
                  {...hit}
                  // images={hit.images}
                  // floorplan={hit.floorplan}
                  // virtual_tour={hit.virtual_tour}
                  Title={hit.developer}
                  Address={hit.title}
                  // status={hit.status}
                  link=""
                  priceQualifier={hit.price_qualifier && hit.price_qualifier}
                  priceDetails={hit.price && hit.price.toLocaleString()}
                  // bedroom={hit.bedroom}
                  // bathroom={hit.bathroom}
                  // reception={hit.reception}
                  // description={hit.description}
                  unkey={uuidv4()}
                  // photoplans={photoplans}
                  source={source}
                  //   videoid={item.video}
                />
                {hit.floorplan && JSON.stringify(hit.floorplan) !== "[]" ? (
                  <FloorPlanModal floorplanimg={hit.floorplan.url} />
                ) : (
                  ""
                )}
                <>
                  {hit.status === "Sold STC" ? (
                    <div className="flag">SOLD STC</div>
                  ) : (
                    ""
                  )}
                  {hit.status === "Let Agreed" ? (
                    <div className="flag">LET AGREED</div>
                  ) : (
                    ""
                  )}
                  {photoplans == true ? (
                    <a
                      href={hit.virtual_tour}
                      target="_blank"
                      className="photoplan"
                    >
                      <span className="play-btn">
                        <i className="icon-play"></i>
                      </span>
                    </a>
                  ) : (
                    <>
                      {hit.virtual_tour ? (
                        hit.virtual_tour.length > 0 ? (
                          <VideoPlay url={hit.virtual_tour} />
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </>
              </div>
            </div>
          ) : (
            <div className="result-tile">
              <Link
                onClick={() =>
                  mycookies.set(mysale, nostats ? hit?.id : hit.objectID, {
                    path: "/",
                    maxAge: 300,
                  })
                }
                // to={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}`}
                propID={nostats ? hit?.id : hit.objectID}
                className="map-wrapper"
              >
                <SearchList
                  {...hit}
                  // images={hit.images}
                  // floorplan={hit.floorplan}
                  // virtual_tour={hit.virtual_tour}
                  Title={hit.developer}
                  Address={hit.title}
                  // status={hit.status}
                  link={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID || hit.id}`}
                  priceQualifier={hit.price_qualifier && hit.price_qualifier}
                  priceDetails={hit.price && hit.price.toLocaleString()}
                  // bedroom={hit.bedroom}
                  // bathroom={hit.bathroom}
                  // reception={hit.reception}
                  // description={hit.description}
                  unkey={uuidv4()}
                  // photoplans={photoplans}
                  source={source}
                  //   videoid={item.video}
                />
              </Link>
            </div>
          )} */}
        </div>
        </>
      )
    })}
  </>
)
  }

export default InfiniteHits;
